import TDevolucion from "./TDevolucion"
import { obtenerDevolucionesAceptadasAction } from "./../../../ducks/devolucionesAceptadas"
import { useEffect } from "react"
import { useDispatch } from "react-redux"

const VDevoluciones = () => {
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerDevolucionesAceptadasAction())
    },[])
    return (
        <div>
            <TDevolucion />
        </div>
    )
}
export default VDevoluciones